import { useEffect, useRef, useState } from "react";
import * as yup from "yup";
import { isDate, parse } from "date-fns";
import {
  isRepeatFieldVisible,
  getFieldValueForValidation,
  collectCrossSectionFieldValues,
} from "Utils/Common/Requisition";

function parseDateString(value: any, originalValue: any) {
  const parsedDate = isDate(originalValue)
    ? originalValue
    : parse(originalValue, "MM/dd/yyyy", new Date());
  return parsedDate;
}
const useYupFormInfectiousData = (
  initialState: any,
  setInfectiousData: any
) => {
  const [inputDataInputsForValidation, setInfectiousDataInputsForValidation] =
    useState(initialState);
  const [errors, setErrors] = useState({});
  const [errosTrack, setErrosTrack] = useState({});
  const infectiousDataRef = useRef(initialState);
  infectiousDataRef.current = initialState;

  useEffect(() => {
    setInitialData();
  }, [initialState]);
  ///
  const setInitialData = () => {
    setInfectiousDataInputsForValidation(initialState);
  };
  // const setDataAndErrors = async (
  //   data: any,
  //   isSaveForLaterRequisitionCheck: boolean = false
  // ) => {
  //   let errorsObj: any = {};
  //   async function convertStringToYupSchema(
  //     stringSchema: string | undefined
  //   ): Promise<yup.Schema<unknown, any, any, "">> {
  //     try {
  //       if (!stringSchema) {
  //         // Return a default Yup schema or `null` schema if the input is undefined
  //         return yup.mixed().nullable().optional();
  //       }
  //       const schema = await new Function("yup", `return ${stringSchema}`)(yup);
  //       if (schema instanceof yup.Schema) {
  //         return schema;
  //       } else {
  //         throw new Error("Invalid schema string.");
  //       }
  //     } catch (error: any) {
  //       throw new Error(
  //         `Error converting string to Yup schema: ${error.message} ${stringSchema}`
  //       );
  //     }
  //   }
  //   const fieldsLoop = async (errors: any, i: number, isValid: boolean) => {
  //     return await new Promise((resolve, reject) => {
  //       const loopField = async () => {
  //         await data[i].fields.forEach((x: any, index: number) => {
  //           if (!isValid) {
  //             let innerError = errors?.inner?.find((y: any) => {
  //               return y.path == x.systemFieldName;
  //             });
  //             //
  //             if (innerError) {
  //               //isValid = false;
  //               data[i].fields[index].enableRule = innerError.message;
  //               // x.enableRule = innerError.message;
  //               errorsObj[x.systemFieldName] = innerError.message;
  //               setErrosTrack((preVal: any) => {
  //                 return {
  //                   ...preVal,
  //                   [x.systemFieldName]: innerError.message,
  //                 };
  //               });
  //             } else {
  //               data[i].fields[index].enableRule = "";
  //               errorsObj[x.systemFieldName] = "";
  //             }
  //           } else {
  //             data[i].fields[index].enableRule = "";
  //             errorsObj[x.systemFieldName] = "";
  //           }
  //         });

  //         return data;
  //       };

  //       resolve(loopField());
  //     });
  //   };

  //   const ValidateInput = async (Inputs: any) => {
  //     for (let i = 0; i < Inputs.length; i++) {
  //       let valueObj: any = {};
  //       let schemaObj: any = {};

  //       for (let y = 0; y < Inputs[i].fields.length; y++) {
  //         if (isSaveForLaterRequisitionCheck) {
  //           if (Inputs[i].fields[y].systemFieldName === "SpecimenID") {
  //             valueObj[Inputs[i].fields[y].systemFieldName] =
  //               Inputs[i].fields[y].defaultValue;
  //             if (
  //               Inputs[i].fields[y].validationExpression !== "" &&
  //               Inputs[i].fields[y].validationExpression !== null
  //             ) {
  //               schemaObj[Inputs[i].fields[y].systemFieldName] =
  //                 await convertStringToYupSchema(
  //                   Inputs[i].fields[y].validationExpression
  //                 );
  //             }
  //           }
  //         } else {
  //           valueObj[Inputs[i].fields[y].systemFieldName] =
  //             Inputs[i].fields[y].defaultValue;
  //           if (
  //             Inputs[i].fields[y].validationExpression !== "" &&
  //             Inputs[i].fields[y].validationExpression !== null
  //           ) {
  //             schemaObj[Inputs[i].fields[y].systemFieldName] =
  //               await convertStringToYupSchema(
  //                 Inputs[i].fields[y].validationExpression
  //               );
  //           }
  //         }
  //       }

  //       try {
  //         await yup
  //           .object()
  //           .shape(schemaObj)
  //           .validateSync(valueObj, { abortEarly: false });
  //         await fieldsLoop(undefined, i, true);
  //       } catch (e: any) {
  //         await fieldsLoop(e, i, false);
  //       }
  //     }
  //   };

  //   await ValidateInput(data);
  //   setErrors(errors);
  //   return { data: data, validation: errorsObj };
  // };
  const setDataAndErrors = async (data: any, saveForSignature: boolean) => {
    let errorsObj: any = {};
    const allErrors = new Map<string, string>(); // Accumulate errors by systemFieldName (unique key)

    async function convertStringToYupSchema(
      stringSchema: string | undefined
    ): Promise<yup.Schema<unknown, any, any, "">> {
      try {
        if (!stringSchema) {
          return yup.mixed().nullable().optional();
        }
        const schema = await new Function(
          "yup",
          "parseDateString",
          `return ${stringSchema}`
        )(yup, parseDateString);
        if (schema instanceof yup.Schema) {
          return schema;
        } else {
          throw new Error(`Invalid schema string: ${stringSchema}`);
        }
      } catch (error: any) {
        throw new Error(
          `Error converting string to Yup schema: ${error.message} ${stringSchema}`
        );
      }
    }

    // Helper to merge accumulated errors into errorsObj (only set if error exists)
    const mergeErrors = () => {
      allErrors.forEach((message, key) => {
        errorsObj[key] = message;
      });
      // Optional: Clear fields with no error (set to "" if not in allErrors)
      // Adjust keys based on your form structure if needed
      Object.keys(errorsObj).forEach(key => {
        if (!allErrors.has(key)) {
          errorsObj[key] = ""; // Only clear if no error anywhere
        }
      });
    };

    ////for billing information field values
    const fieldsRepeatLoop = async (
      errors: any,
      i: number,
      fieldsIndex: number,
      isValid: boolean
    ) => {
      return await new Promise((resolve) => {
        const looprepeateField = async () => {

          console.log(data[i].fields[fieldsIndex].repeatFields, "errors804")
          await data[i].fields[fieldsIndex].repeatFields.forEach(
            (x: any, index: number) => {
              if (!isRepeatFieldVisible(x)) {
                data[i].fields[fieldsIndex].repeatFields[index].enableRule = "";
                return;
              }
              if (!isValid && errors) {
                let innerError = errors.inner.find((y: any) => {
                  return y.path == x.systemFieldName;
                });
                if (innerError) {
                  console.log(innerError, errors, data[i].fields[fieldsIndex].repeatFields, "innerError804")
                  data[i].fields[fieldsIndex].repeatFields[index].enableRule = innerError.message;
                  allErrors.set(x.systemFieldName, innerError.message); // Accumulate, don't overwrite
                  setErrosTrack((preVal: any) => ({
                    ...preVal,
                    [x.systemFieldName]: innerError.message,
                  }));
                  // Optional duplicate log
                  // if (allErrors.has(x.systemFieldName) && allErrors.get(x.systemFieldName) !== innerError.message) {
                  //   console.warn(`Conflicting error for ${x.systemFieldName}: ${allErrors.get(x.systemFieldName)} vs ${innerError.message}`);
                  // }
                } else {
                  // Don't clear global error here—preserve if set elsewhere
                  data[i].fields[fieldsIndex].repeatFields[index].enableRule = "";
                }
              } else {
                data[i].fields[fieldsIndex].repeatFields[index].enableRule = "";
              }
            }
          );

          ///////////////for dependencies validation
          for (
            let y = 0;
            y < data[i].fields[fieldsIndex].repeatDependencyControls.length;
            y++
          ) {
            for (
              let z = 0;
              z < data[i].fields[fieldsIndex].repeatDependencyControls[y].dependecyFields.length;
              z++
            ) {
              const depField =
                data[i].fields[fieldsIndex].repeatDependencyControls[y]
                  .dependecyFields[z];
              if (!isRepeatFieldVisible(depField)) {
                depField.enableRule = "";
                continue;
              }
              if (!isValid && errors) {
                let innerError = errors.inner.find((er: any) => {
                  return er.path == depField.systemFieldName;
                });
                if (innerError) {
                  depField.enableRule = innerError.message;
                  allErrors.set(
                    data[i].fields[fieldsIndex].repeatDependencyControls[y].dependecyFields[z].systemFieldName,
                    innerError.message
                  ); // Accumulate
                  setErrosTrack((preVal: any) => ({
                    ...preVal,
                    [data[i].fields[fieldsIndex].repeatDependencyControls[y].dependecyFields[z].systemFieldName]: innerError.message,
                  }));
                } else {
                  // Don't clear global
                  data[i].fields[fieldsIndex].repeatDependencyControls[y].dependecyFields[z].enableRule = "";
                }
              } else {
                data[i].fields[fieldsIndex].repeatDependencyControls[y].dependecyFields[z].enableRule = "";
              }
            }
          }
          resolve(data);
        };
        looprepeateField();
      });
    };

    ////for fields other than billing information values
    const fieldsLoop = async (errors: any, i: number, isValid: boolean) => {
      return await new Promise((resolve) => {
        const loopField = async () => {
          await data[i].fields.forEach((x: any, index: number) => {
            if (!isValid && errors) {
              let innerError = errors?.inner?.find((y: any) => {
                return y.path == x.systemFieldName;
              });
              if (innerError) {
                data[i].fields[index].enableRule = innerError.message;
                allErrors.set(x.systemFieldName, innerError.message); // Accumulate
                setErrosTrack((preVal: any) => ({
                  ...preVal,
                  [x.systemFieldName]: innerError.message,
                }));
              } else {
                // Don't clear global
                data[i].fields[index].enableRule = "";
              }
            } else {
              data[i].fields[index].enableRule = "";
            }
          });

          ///////////////for dependencies validation
          for (let y = 0; y < data[i].dependencyControls.length; y++) {
            for (
              let z = 0;
              z < data[i].dependencyControls[y].dependecyFields.length;
              z++
            ) {
              if (!isValid && errors) {
                let innerError = errors?.inner?.find((er: any) => {
                  return (
                    er.path ==
                    data[i].dependencyControls[y].dependecyFields[z].systemFieldName
                  );
                });
                if (innerError) {
                  data[i].dependencyControls[y].dependecyFields[z].enableRule = innerError.message;
                  allErrors.set(
                    data[i].dependencyControls[y].dependecyFields[z].systemFieldName,
                    innerError.message
                  ); // Accumulate
                } else {
                  // Don't clear global
                  data[i].dependencyControls[y].dependecyFields[z].enableRule = "";
                }
              } else {
                data[i].dependencyControls[y].dependecyFields[z].enableRule = "";
              }
            }
          }
          resolve(data);
        };
        loopField();
      });
    };

    ///this method is for inputs of billing information for converting string to schema to valid working schema
    const ValidateRepeatInput = async (
      field: any,
      sectionindex: number,
      fieldsIndex: number
    ) => {
      let valueObj: any = {};
      let schemaObj: any = {};

      for (let y = 0; y < field.repeatFields.length; y++) {
        const repeatFieldItem = field.repeatFields[y];
        if (!isRepeatFieldVisible(repeatFieldItem)) continue;

        const key = repeatFieldItem.systemFieldName;
        if (valueObj.hasOwnProperty(key)) {
          if (valueObj[key] !== null && valueObj[key] !== "") continue;
        }
        valueObj[key] = repeatFieldItem.defaultValue;
        if (
          repeatFieldItem.validationExpression !== "" &&
          repeatFieldItem.validationExpression !== null
        )
          schemaObj[key] = await convertStringToYupSchema(
            repeatFieldItem.validationExpression
          );
      }
      ////for dependencies
      for (let y = 0; y < field.repeatDependencyControls.length; y++) {
        for (
          let z = 0;
          z < field.repeatDependencyControls[y].dependecyFields.length;
          z++
        ) {
          const depField = field.repeatDependencyControls[y].dependecyFields[z];
          if (!isRepeatFieldVisible(depField)) continue;

          const key = depField.systemFieldName;
          if (valueObj.hasOwnProperty(key)) {
            if (valueObj[key] !== null && valueObj[key] !== "") continue;
          }
          valueObj[key] = depField.defaultValue;

          if (
            depField.validationExpression !== "" &&
            depField.validationExpression !== null
          )
            schemaObj[key] = await convertStringToYupSchema(
              depField.validationExpression
            );
        }
      }

      var schema = yup.object(schemaObj).describe();
      try {
        await yup
          .object()
          .shape(schemaObj)
          .validateSync(valueObj, { abortEarly: false });
        mergeErrors(); // Merge after successful validation (no new errors)
        return await fieldsRepeatLoop(undefined, sectionindex, fieldsIndex, true);
      } catch (e: any) {
        mergeErrors(); // Merge errors from this catch
        return await fieldsRepeatLoop(e, sectionindex, fieldsIndex, false);
      }
    };

    ///this method is for simple inputs other than billing information for converting string to schema to valid working schema
    const ValidateInput = async (Inputs: any) => {

      console.log(Inputs, "Inputs804")
      for (let i = 0; i < Inputs.length; i++) {
        let valueObj: any = collectCrossSectionFieldValues(Inputs, i);
        let schemaObj: any = {};

        for (let y = 0; y < Inputs[i].fields.length; y++) {
          if (Inputs[i].fields[y] == null) continue;
          if (Inputs[i].fields[y].uiType === "Repeat") {
            data = await ValidateRepeatInput(Inputs[i].fields[y], i, y);
            continue;
          }
          if (
            saveForSignature &&
            (Inputs[i].fields[y].systemFieldName === "PhysicianSignatureType" ||
              Inputs[i].fields[y].systemFieldName === "PhysicianSignature")
          ) {
            continue;
          }
          const key = Inputs[i].fields[y].systemFieldName;
          // Pass the section's fields so a ValidationPanel is measured against
          // its live siblings rather than its own stale aggregate.
          valueObj[key] = getFieldValueForValidation(
            Inputs[i].fields[y],
            Inputs[i].fields
          );
          if (
            Inputs[i].fields[y].validationExpression !== "" &&
            Inputs[i].fields[y].validationExpression !== null
          ) {
            let schema = await convertStringToYupSchema(
              Inputs[i].fields[y].validationExpression
            );
            if (
              Inputs[i].fields[y].systemFieldName === "SpecimenSource" &&
              Inputs[i].fields[y].specimenSources?.length
            ) {
              const specimenSources = Inputs[i].fields[y].specimenSources;
              schema = schema.test(
                "specimen-type-other-required",
                function (value: any) {
                  if (!Array.isArray(value)) return true;
                  for (const item of value) {
                    const panel = specimenSources.find(
                      (p: any) => p.panelID === item.panelID
                    );
                    const option = panel?.specimenSourceOption?.find(
                      (o: any) => o.specimenTypeID === item.specimenTypeID
                    );
                    if (option?.field?.required) {
                      const other = (
                        item.SpecimenTypeOther ??
                        item.specimenTypeOther ??
                        ""
                      ).trim();
                      if (!other) {
                        return this.createError({
                          message: `Site is required for the selected Source`,
                        });
                      }
                    }
                  }
                  return true;
                }
              );
            }
            schemaObj[key] = schema;
          }
        }
        ////for dependencies
        for (let y = 0; y < Inputs[i].dependencyControls.length; y++) {
          const dependencyControl = Inputs[i].dependencyControls[y];
          const controllingFieldValue = valueObj[dependencyControl?.name];
          const dependencyOptionValue = dependencyControl?.value;
          const dependencyOptionLabel = dependencyControl?.label;
          const isAoeBarcodeShippingDependency =
            Number(Inputs[i]?.sectionId) === 137 &&
            String(Inputs[i]?.sectionName ?? "").trim().toLowerCase() ===
              "aoe barcode" &&
            dependencyControl?.name === "DoYouHaveKit";

          // AOE Barcode reuses Address1/City/State/ZipCode across its shipping
          // options. Filter only this known section/controller so later hidden
          // options cannot overwrite the selected option's populated values.
          // Every other dynamic dependency keeps the original validation flow.
          if (
            isAoeBarcodeShippingDependency &&
            controllingFieldValue !== undefined &&
            controllingFieldValue !== null &&
            String(controllingFieldValue) !== "" &&
            String(controllingFieldValue) !== String(dependencyOptionValue) &&
            String(controllingFieldValue) !== String(dependencyOptionLabel)
          ) {
            continue;
          }

          for (
            let z = 0;
            z < Inputs[i].dependencyControls[y].dependecyFields.length;
            z++
          ) {
            const key = Inputs[i].dependencyControls[y].dependecyFields[z].systemFieldName;
            valueObj[key] = Inputs[i].dependencyControls[y].dependecyFields[z].defaultValue;

            if (
              Inputs[i].dependencyControls[y].dependecyFields[z].validationExpression !== "" &&
              Inputs[i].dependencyControls[y].dependecyFields[z].validationExpression !== null
            )
              schemaObj[key] = await convertStringToYupSchema(
                Inputs[i].dependencyControls[y].dependecyFields[z].validationExpression
              );
          }
        }

        try {
          await yup
            .object()
            .shape(schemaObj)
            .validateSync(valueObj, { abortEarly: false });
          mergeErrors(); // No errors from this section
          await fieldsLoop(undefined, i, true);
        } catch (e: any) {
          mergeErrors(); // Capture errors from this section
          await fieldsLoop(e, i, false);
        }
      }
    };
    console.log(data, "data804")
    await ValidateInput(data);
    mergeErrors(); // Final merge
    setErrors(errorsObj); // Assuming this sets global errors
    return { data: data, validation: errorsObj };
  };
  const submitInfectiousInputsForValidation = async (
    saveForLater: boolean = false
  ) => {
    // Always validate against live infectious data (validation copy can be stale).
    const latestInfectiousData =
      infectiousDataRef.current || inputDataInputsForValidation;
    let updatedData = JSON.parse(JSON.stringify(latestInfectiousData));
    console.log(updatedData, "updatedData804")
    let promises = updatedData.map(async (item: any) => {

      if (item?.isSelected) {
        let inputsWithValidationError = await setDataAndErrors(
          item.sections,
          saveForLater
        );
        item.sections = inputsWithValidationError.data;
        return inputsWithValidationError;
      }
    });
    let results = await Promise.all(promises);
    let inputsWithValidationError = results.filter(
      (result) => result !== undefined
    );

    setInfectiousDataInputsForValidation(updatedData);
    setInfectiousData(updatedData);

    let validationErrors = inputsWithValidationError.map(
      (error) => error.validation
    );

    return {
      data: updatedData,
      validation: validationErrors,
    };
  };

  const submitFormSaveForLaterRequisitionValidation = async () => {
    const latestInfectiousData =
      infectiousDataRef.current || inputDataInputsForValidation;
    let updatedData = JSON.parse(JSON.stringify(latestInfectiousData));
    let promises = updatedData.map(async (item: any) => {
      if (item?.isSelected) {
        let inputsWithValidationError = await setDataAndErrors(
          item.sections,
          true
        );
        item.sections = inputsWithValidationError.data;
        return inputsWithValidationError;
      }
    });
    let results = await Promise.all(promises);
    let inputsWithValidationError = results.filter(
      (result) => result !== undefined
    );

    setInfectiousDataInputsForValidation(updatedData);
    setInfectiousData(updatedData);
    let validationErrors = inputsWithValidationError.map(
      (error) => error.validation
    );


    return {
      data: updatedData,
      validation: validationErrors,
    };
  };

  return {
    inputDataInputsForValidation,
    setInfectiousDataInputsForValidation,
    submitInfectiousInputsForValidation,
    submitFormSaveForLaterRequisitionValidation,
  };
};

export default useYupFormInfectiousData;
